import { z } from 'zod';
import { SyncableEntitySchema } from './entity';

export const TaskPrioritySchema = z.enum(['LOW', 'MEDIUM', 'HIGH', 'URGENT']);
export type TaskPriority = z.infer<typeof TaskPrioritySchema>;

export const TaskStatusSchema = z.enum(['TODO', 'IN_PROGRESS', 'DONE']);
export type TaskStatus = z.infer<typeof TaskStatusSchema>;

export const TaskSchema = SyncableEntitySchema.extend({
  title: z.string().min(1),
  description: z.string().default(''),
  dueDate: z.string().datetime().nullable().default(null),
  priority: TaskPrioritySchema.default('MEDIUM'),
  status: TaskStatusSchema.default('TODO'),
  subjectId: z.string().uuid().nullable().default(null),
  chapterId: z.string().uuid().nullable().default(null),
  topicId: z.string().uuid().nullable().default(null),
  pastPaperId: z.string().uuid().nullable().default(null),
  examId: z.string().uuid().nullable().default(null),
});
export type Task = z.infer<typeof TaskSchema>;

export const RevisionEventSchema = SyncableEntitySchema.extend({
  subjectId: z.string().uuid().nullable().default(null),
  topicId: z.string().uuid().nullable().default(null),
  revisionNumber: z.number().int().positive(),
  plannedDate: z.string().datetime(),
  completedDate: z.string().datetime().nullable().default(null),
  notes: z.string().default(''),
}).refine((revision) => revision.subjectId !== null || revision.topicId !== null, {
  message: 'A revision must be linked to a subject or a legacy topic.',
});
export type RevisionEvent = z.infer<typeof RevisionEventSchema>;

export const ExamSchema = SyncableEntitySchema.extend({
  name: z.string().min(1),
  subjectId: z.string().uuid().nullable().default(null),
  examDate: z.string().datetime(),
  targetScore: z.number().min(0).max(100).nullable().default(null),
  notes: z.string().default(''),
});
export type Exam = z.infer<typeof ExamSchema>;

export const GoalSchema = SyncableEntitySchema.extend({
  title: z.string().min(1),
  targetHoursPerDay: z.number().positive().default(6.0),
  targetHoursPerWeek: z.number().positive().default(36.0),
  targetSyllabusPercentage: z.number().min(0).max(100).default(100),
  targetDate: z.string().datetime().nullable().default(null),
  isCompleted: z.boolean().default(false),
});
export type Goal = z.infer<typeof GoalSchema>;
